import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const RecentOrderCard = ({ order }) => {
  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case 'delivered': case'completed':
        return 'text-success bg-success/10';
      case 'processing': case'in progress':
        return 'text-primary bg-primary/10';
      case 'shipped':
        return 'text-accent bg-accent/10';
      case 'cancelled':
        return 'text-error bg-error/10';
      default:
        return 'text-muted-foreground bg-muted';
    }
  };

  const getStatusIcon = (status) => {
    switch (status?.toLowerCase()) {
      case 'delivered': case'completed':
        return 'CheckCircle';
      case 'processing': case'in progress':
        return 'Clock';
      case 'shipped':
        return 'Truck';
      case 'cancelled':
        return 'XCircle';
      default:
        return 'Package';
    }
  };

  const formatDate = (date) => {
    return new Date(date)?.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    });
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 hover:shadow-moderate transition-smooth">
      <div className="flex items-start justify-between mb-3">
        <div className="flex-1">
          <div className="flex items-center space-x-2 mb-2">
            <h4 className="font-semibold text-foreground">Order #{order?.id}</h4>
            <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(order?.status)}`}>
              <Icon name={getStatusIcon(order?.status)} size={12} className="mr-1" />
              {order?.status}
            </span>
          </div>
          
          <div className="space-y-1 mb-3">
            {order?.items?.slice(0, 2)?.map((item, index) => (
              <p key={index} className="text-sm text-muted-foreground">
                {item?.quantity}x {item?.name}
              </p>
            ))}
            {order?.items?.length > 2 && (
              <p className="text-xs text-muted-foreground">
                +{order?.items?.length - 2} more items
              </p>
            )}
          </div>
          
          <div className="flex items-center space-x-4 text-xs text-muted-foreground">
            <span>Ordered: {formatDate(order?.orderDate)}</span>
            {order?.deliveryDate && (
              <span>Delivered: {formatDate(order?.deliveryDate)}</span>
            )}
          </div>
        </div>
        
        <div className="text-right">
          <p className="text-lg font-bold text-foreground mb-2">
            UGX {order?.total?.toLocaleString()}
          </p>
          <div className="flex flex-col space-y-1">
            <Link to={`/order-history?order=${order?.id}`}>
              <Button variant="outline" size="sm" iconName="Eye">
                View
              </Button>
            </Link>
            {order?.canReorder && (
              <Button variant="default" size="sm" iconName="RotateCcw">
                Reorder
              </Button>
            )}
          </div>
        </div>
      </div>
      {order?.trackingNumber && (
        <div className="pt-3 border-t border-border">
          <div className="flex items-center justify-between text-sm">
            <span className="text-muted-foreground">Tracking:</span>
            <span className="font-mono text-foreground">{order?.trackingNumber}</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default RecentOrderCard;